import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import ModalActions from 'reducers/Modal'
import { useTheme } from 'styled-components'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { MaterialIcon } from '@dsny/dsny-component-library'
import PlaylistActions, { thunks as PlaylistThunks } from 'reducers/PlayList'
import NotificationActions from 'reducers/Notification'
import styles from '../Dropdowns.module.scss'
import { NotificationType } from 'constants/enums'
import { Playlistadd } from '@dsny/dsny-component-library/icons'

const TrackPlaylistDropdown = ({
  track = {},
  disabled,
  iconColor,
  triggerClassName,
  triggerLabel,
  triggerStyles = {}
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const theme = useTheme()
  const { playlistAbstracts } = useSelector((state) => state.playList)

  const openNewPlaylistModal = (e) => {
    e.stopPropagation()
    dispatch(PlaylistActions.setSongsToAdd([track.trackid]))
    dispatch(ModalActions.togglePlaylistModal())
  }

  const handleAddToPlaylist = (e, playlist, track) => {
    e.stopPropagation()
    dispatch(
      PlaylistThunks.addTracks(playlist.playlistid, [track.trackid], () =>
        dispatch(
          NotificationActions.broadcastMessage(
            {
              songTitle: track.title,
              playlistTitle: playlist.name
            },
            NotificationType.addedToPlaylist
          )
        )
      )
    )
  }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        aria-label={triggerLabel || t('playlist.add-to-playlist')}
        className={triggerClassName}
        disabled={disabled}
        style={{
          justifySelf: 'center',
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
          outline: 'none',
          boxShadow: 'none',
          ...triggerStyles
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Playlistadd
          width={21}
          height={21}
          color={
            disabled
              ? theme.colors.neutralW40
              : iconColor || theme.colors.neutralW100
          }
        />
      </DropdownMenu.Trigger>

      {!disabled && (
        <DropdownMenu.Portal>
          <DropdownMenu.Content
            style={{
              zIndex: 100,
              background: theme.colors.neutralW20,
              color: theme.colors.neutralW100
            }}
            className={styles.DropdownMenuContent}
            sideOffset={5}
            avoidCollisions
          >
            {playlistAbstracts?.map((playlist) => {
              return (
                <DropdownMenu.Item
                  key={playlist?.playlistid}
                  className={styles.DropdownMenuItem}
                  onClick={(e) => handleAddToPlaylist(e, playlist, track)}
                >
                  {playlist?.name}
                </DropdownMenu.Item>
              )
            })}
            <DropdownMenu.Item
              className={styles.DropdownMenuItem}
              onClick={openNewPlaylistModal}
            >
              {t('playlist.new-playlist')}{' '}
              <div className={styles.RightSlot}>
                <MaterialIcon name="Add" />
              </div>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      )}
    </DropdownMenu.Root>
  )
}

export default TrackPlaylistDropdown
